export default __webpack_public_path__ + "static/media/logo-justo.8e47e861.svg";